
export const past2022 = {
  introduction: {
    subTitle: '—— 西丽湖金融科技大学生挑战赛',
    subTitleEn: 'FinTechathon 深圳国际金融科技大赛',
    titleImg: 'https://static001.geekbang.org/resource/image/f0/af/f08da072d6b2b47ce99bc0314459b4af.png',
    mobileTitleImg: 'https://static001.geekbang.org/resource/image/f0/af/f08da072d6b2b47ce99bc0314459b4af.png',
    intro: [
      '为推动深圳市金融科技产业繁荣发展，抢占金融科技发展先机，丰富金融科技人才储备以打造深圳市金融科技发展高地，深圳大学微众银行金融科技学院、微众银行、深圳香蜜湖国际金融科技研究院联合主办了 2022 深圳国际金融科技大赛（FinTechathon）—— 西丽湖金融科技大学生挑战赛。该大赛由深圳市地方金融监督管理局、深圳市南山区人民政府、深圳市福田区人民政府作为战略指导单位，政、学、企多方分别发挥各自优势，共创金融科技领域盛世赛事先锋。',
      '本届大赛吸引了 364 所国内外院校的逾 1400 名学生组成 500 多支队伍报名参加，共收到超过 230 份作品。大赛评审委员会由来自微众银行的多位技术专家组成，晋级决赛的队伍历时 73 天，经历了初赛作品打磨、云上决赛 36 小时黑客马拉松、小组创意/技术讨论及云上答辩等多轮比拼，最终决胜出了区块链、人工智能、产品经理赛道的前三甲，成功呈现出了一场云上高校 Hackathon。'
    ],
    poster: 'https://static001.geekbang.org/resource/image/16/8e/16533dfe814e00ae19fd3b560193228e.jpg',
    video: 'https://media001.geekbang.org/customerTrans/7e27d07d27d407ebcc195a0e78395f55/52dddda5-18b1db6f75b-0000-0000-01d-dbacd.mp4'
  },

  finalist: {
    // title: '入围决赛队伍',
    // subTitle: 'FINALIST',
    content: [
      {
        alias: 'first',
        title: '一等奖',
        list: [
          {
            image: 'https://static001.geekbang.org/resource/image/da/98/da6fd649ebedc9afb8a0952a30849898.png',
            title: 'Fed-healthcare (联邦医疗)',
            product: '《面向智能体音感知的联邦学习系统-基于FATE平台》',
            alias: 'ai',
            type_title: '人工智能赛道',
            member: '邱万勇、全晨',
            pro_intro: '体音信号因其易采集、普适和“非侵入”等特点被证明可用于临床“非侵入式”智能诊疗。然而，数据安全与隐私问题使得医疗数据呈现“数据孤岛”形式，严重制约了医疗 AI 的发展，该团队的作品便基于以上问题提出了解决方案，本作品是一个在医疗场景下基于FATE联邦学习框架构建智能体音感知系统，可部署于各医院，在保护患者隐私的同时将促进多中心联合建模。'
          },
          {
            image: 'https://static001.geekbang.org/resource/image/ae/24/aefee7175194f79342359bac25e1e424.jpg',
            title: 'TIDAL',
            product: '《面向区块链的细粒度数据权限管理系统》',
            alias: 'blockchain',
            type_title: '区块链赛道',
            member: '赵明阳、谢雨萌、梁浩天、李骐元、罗瑆琪',
            pro_intro: '该团队作品是一个面向区块链的细粒度数据权限管理系统。该作品针对现有区块链应用面临的“不能共享、不愿共享、不敢共享”的痛点问题，应用基于牛顿插值定理的秘密共享技术和变色龙哈希技术等密码学技术，基于微众区块链系列开源技术搭建了一个面向区块链的细粒度数据权限管理系统。在全面保护用户隐私的基础上可以支持细粒度数据权限管理和高效用户撤销机制，希望通过区块链应用切实解决民生需求。'
          }
        ]
      },
      {
        alias: 'second',
        title: '二等奖',
        list: [
          {
            image: 'https://static001.geekbang.org/resource/image/5f/69/5ff94931126a22fae99fyyd295388669.jpg',
            title: 'Intelli5',
            product: '《工业智能协同隐私计算服务平台》',
            alias: 'ai',
            type_title: '人工智能赛道',
            member: '陈洁蔚、李琪琛、吴达、李婷婷、杨国铭',
            pro_intro: '该团队的作品是一款面向 AI 大模型在小微工厂中的应用，是一个基于联邦学习的工业智能协同隐私计算服务平台，助力小微工厂业务数据价值的充分释放。团队研发平台包括用户注册、设备注册、业务查看等基础管理模块和数据接入标准化、聚合策略选择等特殊功能模块，为小微工厂提供降本增效的智能联合建模服务。'
          },
          {
            image: 'https://static001.geekbang.org/resource/image/5b/1d/5b4373e834b37e3a5bcd3b90f23a761d.jpg',
            title: '南山美少女',
            product: '《B-Recycle电池回收管理平台》',
            alias: 'blockchain',
            type_title: '区块链赛道',
            member: '陈绮琳、房美贤、刘宏宇、贺祥瑞、吴雅妃',
            pro_intro: 'B-Recycle 是一个基于 FISCO BCOS 的区块链电池回收管理平台，使用 Vue+SpringBoot 进行前后端搭建，集成了 FISCO BCOS 的 Java-SDK 、区块链消息中间件 WeEvent。 该平台致力于打通动力电池产业链上下游的信息壁垒，以区块链技术助力政府部门监管，以推动产业可持续健康发展。'
          },
          {
            image: 'https://static001.geekbang.org/resource/image/ea/7b/ea34b64e271dc471a78007e296229f7b.jpg',
            title: '绿点',
            product: '《绿点——基于区块链的碳排放权质押贷款平台》',
            alias: 'pm',
            type_title: '产品经理赛道',
            member: '吴倩妮',
            pro_intro: '绿点——金融科技参与下的碳排放权质押贷款平台。借助区块链、人工智能等科技来实现质押物价值的有效确认、差异化贷款利率及借款企业和金融机构的风险难把控等问题。该平台可有效满足中小企业绿色发展中的资金需求，以加速金融机构绿色创新业务发展，激励企业节能减排，助力社会经济实现绿色转型。'
          }
        ]
      },
      {
        alias: 'third',
        title: '三等奖',
        list: [
          {
            image: 'https://static001.geekbang.org/resource/image/57/c9/5773897d391e25e9432490a28d6c6cc9.jpg',
            title: '108战队',
            product: '《计及隐私保护的分区母线电压预测》',
            alias: 'ai',
            type_title: '人工智能赛道',
            member: '颜剑峰、田方正',
            pro_intro: '准确预测分区所在的母线电压，有利于配网中的分区就地自治。关键的挑战是如何确保分区数据能够在不离开隐私域的情况下完成多方联合建模。基于此，该获奖团队提出了一种纵向联邦方案来预测分区母线电压，在避免分区运营商隐私泄露的同时，预测精度可与集中式方案相媲美。此外，他们的作品还对算法的可解释性和适度联邦的必要性进行了探究。'
          },
          {
            image: 'https://static001.geekbang.org/resource/image/1e/67/1ee4e4a219a0baf622f3d8a737b62367.jpg',
            title: 'TEEChain',
            product: '《TEEChain：面向供应链金融的机密区块链系统》',
            alias: 'blockchain',
            type_title: '区块链赛道',
            member: '王伟力、谢绍康、冯泉弼、冯柏钧、李宇轩',
            pro_intro: 'TEEChain——基于可信执行环境的机密区块链系统。区块链技术实现了去中心化账本，具有不可篡改、链上数据可溯源的特性，但区块链在隐私保护上的不足限制了它的应用场景。TEEChain 基于可信执行环境，创新性地对其中可能存在的回滚攻击、侧信道攻击等安全问题进行修复，为链上数据和合约交易提供机密性，切实解决区块链隐私保护难题，促进区块链的更广泛应用。'
          },
          {
            image: 'https://static001.geekbang.org/resource/image/b1/f5/b1e20f1f47cc2d382d15ed184159e4f5.jpg',
            title: '李舒了',
            product: '《WeLiveWeLove 生物云抚养平台》',
            alias: 'pm',
            type_title: '产品经理赛道',
            member: '舒子洋、李丹妮',
            pro_intro: 'WeLiveWeLove 生物云扶养平台是基于区块链（联盟链）技术实现的公益类投资产品，平台致力于为野生动物创建更优良的生存环境，并通过用户对野生动物的一对一抚养来提高大众的环境保护意识。用户可以通过该平台选择自己喜欢的野生动物进行云抚养，获得该生物的抚养凭证并根据该生物的状态获取一定收益。'
          }
        ]
      }
    ]
  }
}
